import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import * as yup from 'yup';
import withModal from '../../../../core/components/withModals';
import FormModalStyled from '../../../../core/components/modals/FormModalStyled';
import AForm from '../../../../core/components/form/AForm';
import ATextInput from '../../../../core/components/inputs/textInput/ATextInput';
import AButton from '../../../../core/components/buttons/AButton';

const AddSectorOpeningTimeModal = (props) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { modalProps, modalData, closeDialog, setModifiedData } = props;
  const [setValueFn, setSetValueFn] = useState(null);
  const [minuteFrom, setMinuteFrom] = useState(modalData?.minuteFrom || 0);

  const fields = [
    {
      id: 'minuteFrom',
      name: t('dailySchedule.sectorOpeningTime'),
      render: <ATextInput type="number" min={0} />
    }
  ];

  const validationSchema = yup.object().shape({
    minuteFrom: yup.number()
      .typeError('Vrijednost mora biti cijeli broj od 0 do 60')
      .integer('Vrijednost mora biti cijeli broj od 0 do 60')
      .min(0, 'Vrijednost mora biti cijeli broj od 0 do 60')
      .max(60, 'Vrijednost mora biti cijeli broj od 0 do 60')
  });

  const submitHandler = (formData) => {
    try {
      if (modalData?.minuteFrom !== minuteFrom && !(!modalData?.minuteFrom && minuteFrom === 0)) {
        setLoading(true);
        if (modalData?.modified) { // ADDING SHIFT OPENING TIME TO MODIFIED CARD
          setModifiedData((prevState) => {
            const newStateArray = [...prevState];
            const newestModifiedDataArray = [];
            prevState?.[prevState?.length - 1]?.forEach((el) => {
              if (el?.timeFrom === modalData?.timeFrom && el?.timeTo === modalData?.timeTo && el?.controllerId === modalData?.controllerId && el?.type !== 'REMOVE') {
                newestModifiedDataArray.push({
                  controllerId: el?.controllerId,
                  timeFrom: el?.timeFrom,
                  timeTo: el?.timeTo,
                  type: 'ADD',
                  sectorId: el?.sectorId,
                  sectorRoleId: el?.sectorRoleId,
                  assignment: el?.assignment === 'ŠS/KL' ? 'SHIFT_MANAGER_AND_CONTROLLER' : el?.assignment === 'OJTI/ASSE' ? 'OJTI_AND_ASSE' : el?.assignment,
                  comment: el?.comment,
                  minuteFrom: formData?.minuteFrom > 0 ? formData?.minuteFrom : null
                });
              } else newestModifiedDataArray.push(el);
            });
            newStateArray.push(newestModifiedDataArray);
            return newStateArray;
          });
        } else { // ADDING SHIFT OPENING TIME TO NON-MODIFIED CARD
          setModifiedData((prevState) => [
            ...(prevState ? prevState : []),
            [
              ...(prevState?.[prevState?.length - 1] ? prevState?.[prevState?.length - 1] : []),
              {
                controllerId: modalData?.controllerId,
                timeFrom: modalData?.timeFrom,
                timeTo: modalData?.timeTo,
                type: 'REMOVE',
                sectorId: modalData?.sectorId,
                sectorRoleId: modalData?.sectorRoleId,
                assignment: modalData?.assignment,
                minuteFrom: modalData?.minuteFrom,
                comment: modalData?.comment
              },
              {
                controllerId: modalData?.controllerId,
                timeFrom: modalData?.timeFrom,
                timeTo: modalData?.timeTo,
                type: 'ADD',
                sectorId: modalData?.sectorId,
                minuteFrom: formData?.minuteFrom ? formData?.minuteFrom : null,
                sectorRoleId: modalData?.sectorRoleId,
                assignment: modalData?.assignment,
                comment: modalData?.comment
              }
            ]
          ]);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
      closeDialog();
    }
  };

  useEffect(() => {
    if (modalData) {
      if (!!modalData?.minuteFrom && modalData?.minuteFrom > 0) {
        setMinuteFrom(modalData?.minuteFrom);
      } else {
        setMinuteFrom(0);
        if (setValueFn) setValueFn('minuteFrom', 0);
      }
    }
  }, [modalData, setValueFn]);

  const formStateChangeHandler = (values) => {
    setMinuteFrom(values?.minuteFrom);
  };

  return (
    <FormModalStyled
      centered
      maskClosable={false}
      width={550}
      footer={[]}
      {...modalProps}
      title={modalData?.minuteFrom ? t('dailySchedule.editSectorOpeningTime') : t('dailySchedule.addSectorOpeningTime')}
    >
      <IntroText>Unesite tačno vrijeme otvaranja sektora u minutama (0-60) od početka sata koje će biti naglašeno u prikazu dnevnog rasporeda u režimu punog ekrana.</IntroText>
      <FormContainer>
        <AForm
          fields={fields}
          modalData={modalData}
          okButtonText={t('buttons.save')}
          cancelButtonText={t('buttons.cancel')}
          onCancel={() => {
            closeDialog();
          }}
          disabled={loading}
          validationSchema={validationSchema}
          modalAddHandler={(formData) => submitHandler(formData)}
          modalEditHandler={(formData) => submitHandler(formData)}
          name="add-sector-opening-time-form"
          onSetValue={setSetValueFn}
          onFormStateChange={formStateChangeHandler}
        />
        <AButton
          onClick={() => setValueFn('minuteFrom', 0)}
          className="resetButton"
          disabled={minuteFrom === 0 || !minuteFrom}
        >
          Obriši prilagođeno vrijeme
        </AButton>
      </FormContainer>
    </FormModalStyled>
  );
};

export default withModal()(AddSectorOpeningTimeModal);

const FormContainer = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  & .aform-footer {
    position: absolute;
    padding-top: 20px;
    padding-bottom: 10px;
    padding-right: 0 !important;
    bottom: 0;
    right: 40px;
  }
  & .resetButton {
    float: right;
    margin-right: 45px;
  }
  & .resetButton:disabled {
    background-color: #B8B8B8 !important;
  }
`;

const IntroText = styled.div`
  white-space: pre-wrap;
  width: 100%;
  padding: 15px 20px;
`;
